class ShippingCheckpoints extends HTMLElement {
  constructor() {
    super();
    this.months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    this.elementsToChange = this.querySelectorAll('[data-dynamic-date="true"]');
    this.updateDates();
    
    document.addEventListener('shopify:section:load', () => {
      this.updateDates();
    });
  }
  
  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  
  getOrdinalSuffix(day) {
    if (day === 1 || day === 21 || day === 31) return 'ST';
    if (day === 2 || day === 22) return 'ND';
    if (day === 3 || day === 23) return 'RD';
    return 'TH';
  }
  
  formatDate(date) {
    const day = date.getDate();
    const month = date.getMonth();
    const ordinal = this.getOrdinalSuffix(day);
    return `${this.months[month]} ${day}${ordinal}`;
  }
  
  updateDates() {
    const currentDate = new Date();
    
    this.elementsToChange.forEach(element => {
      const days = parseInt(element.dataset.days) || 0;
      const minDays = parseInt(element.dataset.minDays) || 0;
      const maxDays = parseInt(element.dataset.maxDays) || 0;
      
      if (days > 0) {
        // Single date
        const date = this.addDays(currentDate, days);
        element.textContent = this.formatDate(date);
      } else if (minDays > 0 && maxDays > 0) {
        // Date range
        const startDate = this.addDays(currentDate, minDays);
        const endDate = this.addDays(currentDate, maxDays);
        const startFormatted = this.formatDate(startDate);
        const endFormatted = this.formatDate(endDate);
        element.textContent = `${startFormatted} - ${endFormatted}`;
      }
    });
  }
}

customElements.define('shipping-checkpoints', ShippingCheckpoints);

